import React, { useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import { availableLanguages } from "lib/config";

import {
  Hidden,
  Collapse,
  ListItemText,
  ListItemIcon,
  ListItem,
  Drawer,
  List,
  Divider,
  IconButton,
  withStyles,
} from "@material-ui/core";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import AssessmentIcon from "@material-ui/icons/Assessment";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Help as HelpIcon,
  Description as DescriptionIcon,
} from "@material-ui/icons";

import LanguageIcon from "@material-ui/icons/Language";

import { useTranslation } from "react-i18next";

import { Link as RouteLink, useLocation } from "react-router-dom";

import PermissionedComponent from "components/PermissionedComponent";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
}));

const LanguageItem = withStyles((theme) => ({
  root: {
    // paddingLeft: theme.spacing(5),
  },
}))(ListItem);

function LanguageSelector({ onDrawerClose }) {
  const { t, i18n } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(() => !open);
  };

  function onCountryClick(lng) {
    i18n.changeLanguage(lng);
    onDrawerClose();
  }

  return (
    <>
      <ListItem
        button
        aria-controls="language-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <ListItemIcon>
          <LanguageIcon />
        </ListItemIcon>

        <ListItemText primary={t("sideNav.language")}></ListItemText>
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {Object.keys(availableLanguages).map((code) => {
            return (
              <LanguageItem
                key={code}
                button
                onClick={() => onCountryClick(code)}
              >
                <ListItemText primary={availableLanguages[code]} />
              </LanguageItem>
            );
          })}
        </List>
      </Collapse>
    </>
  );
}

function ListItemLink({ text, to, newTab }) {
  return (
    <RouteLink
      target={newTab ? "_blank" : undefined}
      style={{ color: "inherit", textDecoration: "none" }}
      to={to}
    >
      <ListItemText primary={text} />
    </RouteLink>
  );
}

function LoginButton({ onClick }) {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <ListItem button onClick={onClick}>
      <ListItemIcon>
        <AccountCircleIcon />
      </ListItemIcon>
      <ListItemLink
        to={{
          pathname: "/login",
          state: { referrer: location },
        }}
        text={t("sideNav.login")}
      />
    </ListItem>
  );
}

function LogoutButton({ onClick }) {
  const { t } = useTranslation();
  return (
    <ListItem button onClick={onClick}>
      <ListItemIcon>
        <ExitToAppIcon />
      </ListItemIcon>

      <ListItemText primary={t("sideNav.logout")} />
    </ListItem>
  );
}

function Download({ onDownloadDialogOpen }) {
  const { t } = useTranslation();

  return (
    <ListItem button onClick={onDownloadDialogOpen}>
      <ListItemIcon>
        <CloudDownloadIcon />
      </ListItemIcon>
      <ListItemText primary={t("sideNav.download")} />
    </ListItem>
  );
}

function downloadIsAllowed(claims) {
  return claims["gd_download"] && claims["gd_download"] !== "none";
}

export default function DrawerMenu({
  onDownloadDialogOpen,
  onHelpOpen,
  currentUser,
  onDrawerClose,
  open,
  onSignOut,
}) {
  const { t } = useTranslation();

  const classes = useStyles();
  const theme = useTheme();

  function handleSignOut() {
    onDrawerClose();
    onSignOut();
  }

  function handleHelpOpen() {
    onDrawerClose();
    onHelpOpen();
  }

  function handleDownload() {
    onDrawerClose();
    onDownloadDialogOpen();
  }

  return (
    <Drawer
      variant="temporary"
      className={classes.drawer}
      anchor="left"
      onClose={onDrawerClose}
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.drawerHeader}>
        <IconButton onClick={onDrawerClose}>
          {theme.direction === "ltr" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </div>
      <Divider />

      <List>
        <LanguageSelector onDrawerClose={onDrawerClose} />

        <Divider />

        <Hidden xsDown>
          <PermissionedComponent isAllowed={downloadIsAllowed}>
            <Download onDownloadDialogOpen={handleDownload} />
          </PermissionedComponent>
        </Hidden>

        <Divider />

        <ListItem>
          <ListItemIcon>
            <AssessmentIcon />
          </ListItemIcon>

          <ListItemLink
            to="/methodology"
            text={t("sideNav.methodology")}
            newTab
          />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>

          <ListItemLink to="/terms.html" text={t("sideNav.terms")} newTab />
        </ListItem>

        <ListItem button onClick={handleHelpOpen}>
          <ListItemIcon>
            <HelpIcon />
          </ListItemIcon>
          <ListItemText primary={t("sideNav.help")} />
        </ListItem>

        {/* <ListItem button>
          <ListItemIcon>
            <GroupIcon />
          </ListItemIcon>
          <ListItemText primary="Créditos" />
        </ListItem> */}
      </List>

      <Divider />

      <List>
        {!currentUser ? (
          <LoginButton />
        ) : (
          <LogoutButton onClick={handleSignOut} />
        )}
      </List>
    </Drawer>
  );
}
